<template>
  <div class="audit-tab">
    <div class="audit-btn">
      <div>已审核考生：{{statusEnums.reviewed}}</div>
      <div>待审核考生：{{statusEnums.checkPendding}}</div>
      <div>已提交考生：{{statusEnums.submitted}}</div>
    </div>
    <div v-if="paperReview && paperReview.isFinish == 0" @click="onSetCheck" class="at-btn" style="margin: 5px 0 10px;">去审核 &gt;</div>
    <el-popover v-if="paperReview && paperReview.isFinish == 0" placement="top" width="200" v-model="visible">
      <p>是否对所有考生进行收卷</p>
      <div>
        <div>已审核考生：{{statusEnums.reviewed}}</div>
        <div>待审核考生：{{statusEnums.checkPendding}}</div>
        <div>已提交考生：{{statusEnums.submitted}}</div>
      </div>
      <div style="text-align: right; margin: 0">
        <el-button size="mini" type="text" @click="visible = false">取消</el-button>
        <el-button type="primary" size="mini" @click="onAuditEnd">确定</el-button>
      </div>
      <div slot="reference" class="at-btn">结束审核</div>
    </el-popover>
  </div>
</template>
<script>
import ApiLogin from '@/apis/api-login.js'
import { arraySplitByKey } from '@/utils/index.js'
export default {
  data() {
    return {
      paperTimer: null,
      isPaperReviewSubject: [],
      visible: false,
    }
  },
  computed: {
    paperReview() {
      return this.$store.state.authimgStore.paperReview
    },
    statusEnums() {
      return this.$store.state.authimgStore.statusEnums
    },
    currentExam() {
      return this.$store.state.authimgStore.currentExam
    },
    currentPhotoList() {
      return this.$store.state.authimgStore.currentPhotoList
    },
  },
  mounted() {
    this.isPaperReviewSubject = this.$utils.$localStorage.get(
      'isPaperReviewSubject'
    )
    this.getExamInfoData()
    this.getExamInfoLoop()
  },
  methods: {
    onSetCheck() {
      if (
        this.paperReview &&
        this.paperReview.reviewList.length &&
        this.statusEnums.checkPendding > 0
      ) {
        if (this.paperReview.isFinish == 1) {
          window.core.showTopTip(1, '审核已结束！')
        } else if (this.paperReview.isFinish == 0) {
          const width = window.core.windowWidth
          window.core.setWebViewWidth(width)
          this.$store.commit('SET_SHOW_AUDIT', true)
        }
      } else {
        window.core.showTopTip(1, '当前无待审核考生！')
      }
    },
    async getExamInfoLoop() {
      this.clearTimer()
      const timer = setInterval(async () => {
        await this.getExamInfoData()
      }, 2000)
      this.paperTimer = timer
      this.$once('hook:beforeDestroy', () => {
        this.clearTimer()
      })
    },
    async getExamInfoData() {
      const userInfo = this.$utils.$localStorage.get('userInfo')
      const res = await ApiLogin.GETpaperReviewStatus({
        roomId: userInfo.roomId,
        roundId: userInfo.roundId
      })
      if (this.paperReview && (this.paperReview.roomId !== res.roomId)) {
        this.$store.dispatch('setCurrentExam', null)
        this.$store.dispatch('setCurrentPhotoList', [])
      }
      // 处理数据添加ossBucket
      if (res.reviewList && res.reviewList.length) {
        res.reviewList.forEach(v => {
          if (v.photoList && v.photoList.length) {
            v.photoList.forEach(k => {
              if (v.ossBucket === null || v.ossBucket === 'null') {
                k.ossBucket = ''
              } else {
                k.ossBucket = v.ossBucket
              }
            })
          }
        })
      }
      this.getHistoryImg(res)
      this.$store.dispatch('setPaperReviewData', res)
      if (res.reviewList && res.reviewList.length) {
        if (!this.currentExam) {
          this.$store.dispatch('setCurrentExam', res.reviewList[0])
          this.$store.dispatch('setCurrentPhotoList', res.reviewList[0].list)
        } else {
          const { examSubjectId, examId, reviewStatus } = this.currentExam
          const target =
            res.reviewList.filter(
              (v) =>
                v.examSubjectId == examSubjectId &&
                v.examId == examId &&
                v.reviewStatus !== reviewStatus
            ) || []
          if (target.length) {
            this.$store.dispatch('setCurrentExam', target[0])
            this.$store.dispatch('setCurrentPhotoList', target[0].list)
          }
        }
      } else {
        this.$store.dispatch('setCurrentExam', null)
        this.$store.dispatch('setCurrentPhotoList', [])
      }
      this.$store.dispatch('setStatusEnums')
    },
    // 处理历史打回的图片
    getHistoryImg(res) {
      if (res.reviewList && res.reviewList.length) {
        res.reviewList.forEach((k) => {
          const current =
            this.isPaperReviewSubject.filter(
              (v) => v.guideSubjectId == k.subjectId
            ) || []
          let plist = []
          if (current && current.length) {
            k.currentSubject = current[0]
            plist = current[0].photoLabels.map((v, i) => {
              return { name: v, index: i + 1 }
            })
          }
          if (plist && plist.length == 0) {
            const slist = this.formatPhoto(k.photoList)
            plist = slist.map((v) => {
              return { name: v.index, index: v.index }
            })
          }
          if (k.photoList && k.photoList.length) {
            k.list = this.formatPhoto(k.photoList)
            k.list = this.comparePhotos(plist, k.list)
          } else {
            k.list = this.comparePhotos(plist, k.list)
          }
        })
      }
    },
    formatPhoto(arr) {
      let result = []
      arr.sort((a, b) => b.addTime - a.addTime)
      result = arraySplitByKey(arr, 'index', 'history')
      result.sort((a, b) => a.index - b.index)
      return result
    },
    comparePhotos(tarList, curList = []) {
      let result = []
      result = tarList.map((v) => {
        const tar = curList.filter((k) => k.index == v.index)
        if (tar && tar.length) {
          v = { ...v, ...tar[0] }
        } else {
          v = { ...v, fileUrl: '', status: -1 }
        }
        return { ...v }
      })
      return result
    },
    clearTimer() {
      if (this.paperTimer) {
        clearInterval(this.paperTimer)
        this.paperTimer = null
      }
    },
    async onAuditEnd() {
      const userInfo = this.$utils.$localStorage.get('userInfo')
      await ApiLogin.POSTpaperReviewFinish({
        roomId: userInfo.roomId,
        roundId: userInfo.currentRoundId || userInfo.roundId,
        examType: userInfo.examType
      })
      this.visible = false
      window.core.showTopTip(1, '审核已结束！')
      this.onClose()
    },
    onClose() {
      const { examId } = this.currentExam
      window.core.closeCheckingExaminee(examId || '')
      this.$store.commit('SET_SHOW_AUDIT', false)
      window.core.setWebViewWidth(240)
      this.clearTimer()
    },
  },
}
</script>
<style lang="scss" scoped>
.audit-tab {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .at-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 160px;
    height: 32px;
    border: 1px solid #ffffff;
    border-radius: 16px;
    cursor: pointer;
  }
  .audit-btn {
    padding: 10px 0;
  }
}
</style>
